import styled from 'styled-components';
import { rem } from 'polished';
import { ModalDemoVehicleInfoStyled } from '../ModalDemoVehicleInfoStyled';

export const ModalDemoVehicleInfoStyledDS = styled(ModalDemoVehicleInfoStyled)`
    
`;
